function initDelegatedCopyButtons() {
    if (window.__delegatedCopyButtonsV1Initialized) {
        return;
    }

    window.__delegatedCopyButtonsV1Initialized = true;

    const triggerSelector = '.js-copy-button[data-copy-content]';
    const successClass = 'btn-success';
    const failureClass = 'btn-danger';

    /**
     * @param {HTMLButtonElement} button
     */
    const restoreButtonAppearance = (button) => {
        button.textContent = button.dataset.copyDefaultLabel || 'Copy';
        button.classList.remove(successClass, failureClass);
    };

    /**
     * @param {HTMLButtonElement} button
     * @param {string} label
     * @param {string} stateClass
     */
    const showTemporaryState = (button, label, stateClass) => {
        if (button.__copyButtonRestoreTimer) {
            clearTimeout(button.__copyButtonRestoreTimer);
        }

        button.textContent = label;
        button.classList.remove(successClass, failureClass);
        button.classList.add(stateClass);

        // noinspection JSUndefinedPropertyAssignment
        button.__copyButtonRestoreTimer = window.setTimeout(() => {
            restoreButtonAppearance(button);
        }, 1200);
    };

    /**
     * @param {string} textToCopy
     * @return {Promise<void>}
     */
    const copyText = async (textToCopy) => {
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(textToCopy);
            return;
        }


        // Fallback
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        // noinspection JSDeprecatedSymbols
        const didCopy = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (!didCopy) {
            throw new Error('Failed to copy');
        }
    };

    // Delegated click so this also works on AJAX-injected HTML.
    document.addEventListener('click', async (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        const trigger = event.target.closest(triggerSelector);

        if (!trigger || !(trigger instanceof HTMLButtonElement) || trigger.disabled) {
            return;
        }

        event.preventDefault();

        try {
            await copyText(trigger.dataset.copyContent || '');

            showTemporaryState(
                trigger,
                trigger.dataset.copySuccessLabel || 'Copied',
                successClass,
            );
        } catch (error) {
            showTemporaryState(
                trigger,
                trigger.dataset.copyFailureLabel || 'Failed',
                failureClass,
            );
        }
    });
}

export {initDelegatedCopyButtons};
